<template>
  <SideSheet
    class="deallocate-limit"
    data-testid="deallocate-limit"
    position="right"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <NavBar sticky>
      <template #left>
        <BackButton icon="EF0030" @click="$emit('close')" />
      </template>
    </NavBar>
    <HelperViewContextual
      class="deallocate-limit__helper"
      title="Desalocar limite?"
      description="Seu saldo alocado e prejuízo máximo serão desalocados imediatamente."
      icon="BA0030"
      context="info"
    />
    <ButtonContainer class="deallocate-limit__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Confirmar"
          size="large"
          :loading="dataForm.isUpdatingLimits"
          @click="confirmDealocate"
        />
      </template>
      <template #button-secondary>
        <ButtonSecondary
          label="Cancelar"
          size="large"
          @click="$emit('close')"
        />
      </template>
    </ButtonContainer>
  </SideSheet>
</template>

<script lang="ts" setup>
import { inject, Ref, watch } from 'vue';

import {
  NavBar,
  HelperViewContextual,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface EmitEvents {
  (event: 'close'): void;
}
const emit = defineEmits<EmitEvents>();

interface Props {
  isOpen: boolean;
}
const props = defineProps<Props>();

const fetchUpdateLimits = inject(
  'fetchUpdateLimits',
  async (isDeallocate: boolean) => ({ isDeallocate })
);
const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: object) => ({
    key,
    value
  })
);

const dataForm = inject('dataForm') as Ref<{ isUpdatingLimits: boolean }>;

async function confirmDealocate() {
  updateDataForm('balance', { value: 0, formatted: '' });
  updateDataForm('drawdown', { value: 0, formatted: '' });

  await fetchUpdateLimits(true);

  emit('close');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);
</script>

<style lang="less" scoped>
.deallocate-limit {
  height: 100vh;

  .navbar-container {
    border-bottom: none;
  }

  :deep(.panel-content.right) {
    width: 683px;
  }

  &__helper {
    :deep(.initial-avatar-icon) {
      color: @status-info;
      background-color: @status-info-background;
    }

    width: 300px;
    margin: 0 auto;
    height: calc(100vh - 162px);
    justify-content: center;
  }

  &__button-container {
    background-color: @background-secondary;
    width: 683px;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 20;
  }
}
</style>
